import React, { useState } from "react";
import "./security.scss";
import Navbar from '../landing/header/Navbar';
import { motion, AnimatePresence } from "framer-motion";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Workflows from '../landing/workflows/Workflows';
import Headernew from "../landing/headernew/Headernew";
const Security = () => {
  const services = [
    {
      title: "Network and Infrastructure Management:",
      icon: "/assets/cube.svg",
      short: [
        "Sleep Easy: Your network is our watch.",
      ],
      middle: [
        "Our experts monitor and manage your network 24/7, ensuring optimized performance, reliability, and scalability.",
      ],
      bottom: [
        "Email migration, backup, and Teams provisioning",
        "Azure AD & endpoint integration",
        "Secure cloud backup & disaster recovery",
        "SharePoint intranet & document libraries",
      ],
    },

    {
      title: "Azure Services Management:",
      icon: "/assets/cube.svg",
      short: ["Azure-Certified Expertise: Your Azure services will be managed by our team of Azure-certified professionals."],
      middle: ["We ensure your cloud journey with Azure is smooth, secure, and efficient, unlocking the full potential of Azure’s offerings for your business."],
      bottom: ["Data loss prevention", "Phishing protection", "Multi-factor auth", "Cloud lock"],
    },
    {
      title: "O365 Management and Support",
      icon: "/assets/cube.svg",
      short: ["Boost Your Productivity: Unleash the power of O365 apps with our management services."],
      middle: ["From setup to support, we tailor Office 365 applications to your business needs."],
      bottom: ["RTO/RPO configuration", "Disaster recovery testing", "Secure encryption", "Multi-region support"],
    },
    {
      title: "Enhanced Endpoint Security",
      icon: "/assets/cube.svg",
      short: ["Endpoint Protection: We fortify your business against cyber threats with comprehensive endpoint security. "],
      middle: ["Our advanced protocols safeguard against malware, phishing, and unauthorized access, ensuring your network and devices remain secure."],
      bottom: ["Workflow automation", "Power Platform support", "Metadata tagging", "External sharing policies"],
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const [expanded, setExpanded] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const options = {
    margin: window.innerWidth > 600 ? 20 : 10,
    loop: true,
    autoplay: window.innerWidth > 600 ? true : false,
    autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
    autoplayHoverPause: window.innerWidth > 600 ? true : false,
    smartSpeed: 600,
    autoplaySpeed: 600,
    nav: true,
    dots: false,
    navText: [
      "<img src='/assets/left.svg'/>",
      "<img src='/assets/right.svg'/>",
    ],
    responsive: {
      0: { items: 1 },
      300: { items: 1.1 },
      400: { items: 1.1 },
      600: { items: 1.1 },
      1000: { items: 2.5 },
      1300: { items: 3.5 },
      1700: { items: 4.5 },
    },
  };

  const testimonials = [
    {
      name: "Compliance Assessment & Gap Analysis",
      quote:
        "Dive deep into your current compliance posture with our expert analysis, identifying gaps and outlining actionable steps towards full compliance.",
      img: "/assets/doone.svg",
    },
    {
      name: "Policy Development & Implementation",
      quote:
        "Receive bespoke policy frameworks that are not just compliant but are also aligned with your unique business operations, fostering a secure and regulated environment.",
      img: "/assets/dotwo.svg",
    },
    {
      name: "Thorough Security Audits",
      quote:
        "Benefit from exhaustive audits that scrutinize your security measures against industry standards and regulatory requirements, ensuring no stone is left unturned.",
      img: "/assets/dothree.svg",
    },
    {
      name: "Tailored Security Awareness Training",
      quote:
        "Elevate your team's security knowledge with customized training sessions designed to instill best practices and proactive defense strategies.",
      img: "/assets/dofour.svg",
    },

    {
      name: "Incident Response Planning",
      quote:
        "Stay prepared with a robust incident response plan that enables swift action and minimizes impact in the event of a security breach.",
      img: "/assets/dofour.svg",
    },
  ];

  const cardsData = [
    {
      title: "Stay Ahead of Risks",
      para: "Navigate the evolving security landscape with confidence, backed by our expertise in preempting compliance risks and vulnerabilities.",
      img: "/assets/paone.svg",
    },
    {
      title: "Data Protection Guaranteed",
      para: "Our commitment is the safeguarding of your invaluable data through comprehensive strategies and relentless attention to detail.",
      img: "/assets/patwo.svg",
    },
    {
      title: "Regulatory Excellence",
      para: "Ensure your organization not only meets but excels in regulatory and industry-standard compliance, avoiding penalties and fostering trust.",
      img: "/assets/pafour.svg",
    },
    {
      title: "Customized for Your Business",
      para: "Recognizing the uniqueness of each organization, we tailor our services to perfectly align with your specific needs and challenges.",
      img: "/assets/pafive.svg",
    },
    {
      title: "Expert Support",
      para: "Our team of information security compliance specialists is your dedicated ally, equipped to guide you through every step of the compliance journey.",
      img: "/assets/pathree.svg",
    },
    {
      title: "Lorem Ipsum",
      para: "Our commitment is the safeguarding of your invaluable data through comprehensive strategies and relentless attention to detail.",
      img: "/assets/patwo.svg",
    },
  ];


  return (
    <>
      <section className="main-banner security_main">
        <Headernew />
        <video
          className="main-banner-video"
          muted
          playsInline
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/assets/bannervideo.mp4" type="video/mp4" />
        </video>

        <div className="custom-container1">
          <div className="top_banner">
            <motion.h3
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: false }} // 👈 animation runs every time on scroll
              transition={{ duration: 1 }}
            >
              Compliance & Governance
            </motion.h3>
            <motion.h4
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: false }} // 👈 animation runs every time on scroll
              transition={{ duration: 1 }}
            >
              <div className='elevate_mains'>
                <h4>Elevate Your Compliance Posture with TechSecure360</h4>
                <p>Let the complexities of compliance become a thing of the past. With TechSecure360, you gain a partner dedicated to your security and compliance excellence. Transform your approach to information security compliance and build a stronger, more resilient organization</p>
              </div>
            </motion.h4>

          </div>
        </div>
      </section>
      <div className='marque_div'>
        <h3>Trusted By Clients Across Industries</h3>
        <div className="trendinganimations">
          <div className="trendinganimationsright">
            <div className="marquee">
              <div className="marquee__group">
                <div>
                  <img className='imgunder' src="\assets\1.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\2.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\3.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\4.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\5.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\6.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\7.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\8.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\9.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\10.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\1.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\2.png" />
                </div>





                <div>
                  <img className='imgunder' src="\assets\11.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\12.png" />
                </div>


              </div>
              <div aria-hidden="true" className="marquee__group">
                <div>
                  <img className='imgunder' src="\assets\1.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\2.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\3.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\4.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\5.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\6.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\7.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\8.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\9.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\10.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\1.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\2.png" />
                </div>

                <div>
                  <img className='imgunder' src="\assets\11.png" />
                </div>
                <div>
                  <img className='imgunder' src="\assets\12.png" />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='nnew_cardfss'>
        <div className='custom-container1'>

          <div className='challenge'>
            <h5>Common Compliance Challenges We Solve</h5>
            <div className='eight_cards111'>
              <div className='cardnnnne'>
                <img src='\assets\reeee.svg' />
                <h6>Navigate Complex Regulations</h6>
                <p>We interpret evolving standards like ISO 27001, SOC2, GDPR, NIST... and keep you compliant.</p>
              </div>
              <div className='cardnnnne'>
                <img src='\assets\reeee.svg' />
                <h6>Inefficient Audit Preparation</h6>
                <p>Automate evidence gathering and maintain audit-ready documentation.</p>
              </div>
              <div className='cardnnnne'>
                <img src='\assets\reeee.svg' />
                <h6>Fragmented Risk Management</h6>
                <p>Connect assessments to uncover and mitigate vulnerabilities organization-wide.</p>
              </div>

              <div className='cardnnnne'>
                <img src='\assets\reeee.svg' />
                <h6>Policy Governance Gaps</h6>
                <p>Keep policies current, accessible, and enforced to drive compliance.</p>
              </div>
              <div className='cardnnnne'>
                <img src='\assets\reeee.svg' />
                <h6>Third-Party Risk Blind Spots</h6>
                <p>Ensure vendors meet compliance standards and reduce external threats.</p>
              </div>

              <div className='cardnnnne'>
                <img src='\assets\reeee.svg' />
                <h6>Ineffective Incident Response</h6>
                <p>Contain breaches swiftly and meet regulatory reporting with confidence.</p>
              </div>


            </div>
            <h3>What if we could handle all this for you?<br></br>
              keeping your compliance secure, streamlined, and audit-ready without the burden on your team?</h3>
          </div>

        </div>

      </div>

      <section className="slider_Div">

        <div className='custom-container1'>

          <h5>What We Do</h5>

          <div className="cardshead">
            <OwlCarousel className="owl-theme" {...options}>
              {testimonials.map((t, i) => (
                <motion.div
                  key={i}
                  className="cards"
                  variants={cardVariants}
                  initial="visible"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.4 }}
                >
                  <img className="imgggg" src={t.img} alt={t.name} />                <h2>{t.name}</h2>
                  <h3>{t.title}</h3>
                  <p>“{t.quote}”</p>
                </motion.div>
              ))}
            </OwlCarousel>
          </div>

        </div>


      </section>


      <section className='secure_main1'>
        <img src='/assets/elipses.png' className='elipses' alt='background design' />
        <div className='custom-container1'>
          <div className='inner_secure'>
            <h3>Why TechSecure360?
            </h3>
            <div className='parent_four_cards'>
              {cardsData.map((card, index) => (
                <motion.div
                  className='onne_card'
                  key={index}
                  custom={index}
                  variants={cardVariants}
                  initial='hidden'
                  whileInView='visible'
                  viewport={{ once: false, amount: 0.3 }}
                >
                  <div>
                    <h4>{card.title}</h4>
                    <p>{card.para}</p>
                  </div>
                  <img src={card.img} alt={card.title} />
                </motion.div>
              ))}
            </div>

          </div>
        </div>
        <p className='textdiv'>At TechSecure360, we are committed to helping organizations meet regulatory compliance requirements, strengthen their security measures, and effectively respond to security incidents. Contact us today to ensure your organization's security and regulatory needs are met with excellence.</p>
      </section>


      <div className='sub_mains'>
        <div className='custom-container1'>
          <h3>Compliance Subscriptions</h3>

          <div className='two_cardsmains'>
            <div className='leftsidecards'>
              <img src='\assets\shadee.png' className='shadeneww' />
              <h4>Compliance Starter</h4>
              <h5>$799/Month</h5>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Basic Compliance Assessment & Gap Analysis

              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Standard Policy Development & Implementation Support

              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Annual Security Audit Against Industry Standards
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Customized Security Awareness Training (Annually)
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Basic Incident Response Planning
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Quarterly Compliance Monitoring & Updates
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Email Support for Compliance Queries
              </h6>
              <Link to="/contactus">
                <button className='bluebutton'>Contact Us</button>
              </Link>

            </div>

            <div className='rightsidecards'>
              <h4>Pro Package</h4>
              <h5>$1399/Month</h5>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Comprehensive Compliance Assessment & Gap Analysis


              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Advanced Policy Development & Implementation

              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Detailed Security Audits Against Industry Standards (Semi-annually)
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Customized Security Awareness Training (Semi-annually)
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Strategic Incident Response Planning

              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Continuous Compliance Monitoring & Updates
              </h6>
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
              </svg>Dedicated Support for Compliance Queries (Direct Access)
              </h6>
              <Link to="/contactus">
                <button className='whitebutton'>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>

      </div>
      <section className='work_main newmainns'>
        {/* Background Shade Image */}
        <motion.img
          src='/assets/shade.png'
          className='imggshade'
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: false }}
          alt='background shade'
        />

        {/* Background Video */}
        <motion.video
          className='main-banner-video'
          muted
          playsInline
          autoPlay
          loop
          width="100%"
          id="myVideo"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
          viewport={{ once: false }}
        >
          <source src="/assets/bottomvideo.mp4" type="video/mp4" />
        </motion.video>

        <div className='custom-container1'>
          <motion.div
            className='inner_work'
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false }}
          >
            <h2>Ready to Talk?</h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              viewport={{ once: false }}
            >
              Let’s explore how we can support your team:
            </motion.p>

            <motion.div
              className='buttons_div'
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              viewport={{ once: false }}
            >
              <a href="https://www.techsecure360.com" target="_blank" rel="noopener noreferrer">
                <button className="thrree">www.techsecure360.com</button>
              </a>

              <a href="mailto:info@techsecure360.com">
                <button className="thrree">info@techsecure360.com</button>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </section>

    </>
  )
}

export default Security
